"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.participate = void 0;
var env_1 = require("../../env");
exports.participate = {
  id: 'participate',
  label: 'Participate',
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:participate'] : null,
  children: [{
    id: 'programs',
    type: 'list',
    entityTypeName: 'Program',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:programs'] : null
  }, {
    id: 'solutions',
    type: 'list',
    entityTypeName: 'ImpactStory',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:solutions'] : null
  },
  // TODO - have a way to expand spaces into their types in this list 
  // so "Working Groups" is a type, and it would continue to show a listing here
  {
    id: 'spaces',
    type: 'list',
    entityTypeName: 'Space',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:spaces'] : null
  }, {
    id: 'teams',
    type: 'list',
    entityTypeName: 'Team',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:teams'] : null
  }, {
    id: 'events',
    type: 'list',
    entityTypeName: 'Event',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:events'] : null
  }, {
    id: 'courses',
    type: 'list',
    entityTypeName: 'Course',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:courses'] : null
  }]
};